import { render, staticRenderFns } from "./UserRoleConfig.vue?vue&type=template&id=1808961d&scoped=true"
import script from "./UserRoleConfig.vue?vue&type=script&lang=js"
export * from "./UserRoleConfig.vue?vue&type=script&lang=js"
import style0 from "./UserRoleConfig.vue?vue&type=style&index=0&id=1808961d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1808961d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1808961d')) {
      api.createRecord('1808961d', component.options)
    } else {
      api.reload('1808961d', component.options)
    }
    module.hot.accept("./UserRoleConfig.vue?vue&type=template&id=1808961d&scoped=true", function () {
      api.rerender('1808961d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/roleApi/UserRoleConfig.vue"
export default component.exports